<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm02_hd">
<h1 class="h1" id="fm02_hd"><span aria-label=" page 1. " epub:type="pagebreak" id="page_1" role="doc-pagebreak">Los Angeles Times</span></h1>
<p class="sutxt">International Section, May 3, 1984</p>
<p class="indent">Incredibly, a six-month-old baby girl has been pulled from the fiery wreckage of Japan Airlines flight 999. Japanese investigators are looking for any clues that might lead to the miracle baby’s identity or the whereabouts of her relatives. At press time no one had stepped forward to claim the young girl….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?6065e776